// Employee/components/View/SlotConfirmationModal.tsx
import React from "react";
import Button from "Core/components/elements/Button/Button";
import Modal from "Core/components/elements/Modal/Modal";
import moment, {Moment} from "moment";

interface SlotConfirmationModalProps {
    isModalOpen: boolean;
    setIsModalOpen: (open: boolean) => void;
    onConfirm: (slot: Moment) => void;
    selectedSlot: moment.Moment;
}

const SlotConfirmationModal: React.FC<SlotConfirmationModalProps> = ({
                                                                         isModalOpen,
                                                                         setIsModalOpen,
                                                                         onConfirm,
                                                                         selectedSlot,
                                                                     }) => {
    const handleConfirmClick = () => {
        onConfirm(selectedSlot); // Pass the selected slot when confirming
    };

    return (
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
            <div className="fc gap-3">
                <h4>Подтверждение выбора</h4>
                <p>Вы выбрали {selectedSlot.format("dddd, DD MMMM, HH:mm")}</p>
                <div className="frc gap-2">
                    <Button variant={'contained'} onClick={handleConfirmClick}>
                        Да
                    </Button>
                    <Button variant="outlined" onClick={() => setIsModalOpen(false)}>
                        Отмена
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default SlotConfirmationModal;
